/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAchievementByTrackId, useCreateAchievement, useUpdateAchievement } from './achievementQueries';
import { useTrack } from '../tracks';
import { useUpdateAwardPermission } from '../awards/awardsQueries';
// @ts-expect-error Untyped import
import { getAchievementCreationData } from '../../selectors/achievementSelectors';
import { useTrackAwardProgress } from '../userProgress';
import getLang from 'LearningCenterUI/utils/getLang';
export const useMaybeCreateOrUpdateAchievement = trackId => {
  const {
    achievement,
    achievementsLoading,
    achievementsError
  } = useAchievementByTrackId(trackId);
  const {
    award
  } = useTrackAwardProgress(Number(trackId));
  const {
    track,
    trackLoading
  } = useTrack(Number(trackId), award && (award.language || getLang()), !award);
  const achievementCreationData = useSelector(state => !!track && !!award && getAchievementCreationData(state, {
    award,
    track,
    trackId
  }) || undefined);
  const [createAchievement, {
    createAchievementLoading
  }] = useCreateAchievement(achievementCreationData);
  const [updateAchievement] = useUpdateAchievement(achievement, achievementCreationData && {
    [achievementCreationData.language]: {
      urlSlug: achievementCreationData.urlSlug
    }
  } || {});
  const isAwardInvalid = !award || !track;
  useEffect(() => {
    if (achievementCreationData && !achievementsLoading && !createAchievementLoading && !trackLoading && !isAwardInvalid) {
      if (!achievement) {
        createAchievement();
      } else if (achievement.publicId && !achievement.metadata[achievementCreationData.language]) {
        updateAchievement();
      }
    }
  }, [achievement, achievementCreationData, achievementsLoading, createAchievement, createAchievementLoading, isAwardInvalid, trackLoading, updateAchievement]);
  return {
    track,
    trackLoading,
    isAwardInvalid,
    achievementsLoading,
    achievementsError
  };
};
export const useUpdatePrivacy = ({
  trackId,
  awardCode,
  shouldBePublic
}) => {
  const {
    achievement
  } = useAchievementByTrackId(trackId);
  const [updateAchievement, {
    updateAchievementGlobalLoading
  }] = useUpdateAchievement(achievement, undefined, shouldBePublic ? 'PUBLIC' : 'PRIVATE');
  const [updateAwardPermission, {
    updateAwardPermissionGlobalLoading
  }] = useUpdateAwardPermission(awardCode /* guarded by condition in updatePrivacy */, shouldBePublic);
  const updatePrivacy = useCallback(() => {
    if (!awardCode) {
      return;
    }
    updateAchievement();
    updateAwardPermission();
  }, [awardCode, updateAchievement, updateAwardPermission]);
  return {
    updatePrivacy,
    updatePrivacyLoading: updateAwardPermissionGlobalLoading || updateAchievementGlobalLoading
  };
};
export const useAchievementStatus = trackId => {
  const {
    achievement
  } = useAchievementByTrackId(trackId);
  const {
    award
  } = useTrackAwardProgress(Number(trackId));
  const isPrivate = !!achievement && !!award && (achievement.private || award.visibility === 'PRIVATE');
  const {
    updatePrivacyLoading
  } = useUpdatePrivacy({
    trackId,
    awardCode: award && award.code,
    shouldBePublic: !isPrivate
  });
  const isDisabled = !award || !achievement || updatePrivacyLoading || isPrivate;
  return {
    isPrivate,
    isDisabled
  };
};